import React, {Fragment} from 'react';
import {Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {RefundCardTitleProps} from './types';

const {protocol} = translations['pt-br'].commons;

export function RefundCardTitle({highlightedText}: RefundCardTitleProps) {
	return (
		<Fragment>
			<Typography fontSize="1.25rem" component="span">
				{protocol}
			</Typography>{' '}
			{highlightedText}
		</Fragment>
	);
}
